import {
  useClearRefinements,
  type UseClearRefinementsProps,
} from 'react-instantsearch'

import { useProductSearchContext } from '../context/productSearchContextValue'

export const useProductSearchClearRefinements = (
  props?: UseClearRefinementsProps,
): ReturnType<typeof useClearRefinements> => {
  const clearRefinements = useClearRefinements(props)
  const { requestClearAll } = useProductSearchContext()

  return {
    ...clearRefinements,
    refine: (): void => {
      requestClearAll()
      clearRefinements.refine()
    },
  }
}
